import {
  Alert,
  Box,
  Checkbox,
  CircularProgress,
  LinearProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import axios from "axios";
import useApiEp from "../../../hooks/useApiEp";
import LoadingWidget from "../../../widgets/LoadingWidget";
import { getErrorResponse } from "../../../utils/util";
import { useEffect, useMemo } from "react";
import PageTitle from "../../../widgets/PageTitle";
const ContactListGroup = ({ group, onLoaded }) => {
  const { data, isLoading, isError, error } = useApiEp(
    `/user/get-contacts-group-campaign?group=${group}`
  );
  const columnKeys = useMemo(() => {
    if (!data?.length) return [];
    return Object.keys(data[0]).filter((item) => item !== "_id");
  }, [data]);
  useEffect(() => {
    if (data) {
      onLoaded?.(data);
    }
  }, [data]);

  if (isLoading) {
    return <LinearProgress />;
  }
  if (isError) {
    return <Alert severity="error">{getErrorResponse(error)}</Alert>;
  }
  return (
    <Box>
      <Typography variant="body1">Showing one contact for preview</Typography>
      <Typography variant="caption">Total contacts {data.length}</Typography>
      <TableContainer
        sx={{ maxHeight: 300 }}
        component={Paper}
        variant="outlined"
        elevation={0}
      >
        <Table size="small">
          <TableHead>
            <TableRow>
              {columnKeys.map((key) => (
                <TableCell key={key}>{key.replace(/_/g, " ")}</TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {[data[0]].map((row) => {
              return (
                <TableRow hover key={row._id}>
                  {columnKeys.map((key) => (
                    <TableCell key={key}>{row[key] ?? ""}</TableCell>
                  ))}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default ContactListGroup;
